export var StoreSearchType;
(function (StoreSearchType) {
  StoreSearchType["STOCK"] = "STOCK";
  StoreSearchType["DELIVERY"] = "DELIVERY";
  StoreSearchType["STOCK_AND_DELIVERY"] = "STOCK_AND_DELIVERY";
})(StoreSearchType || (StoreSearchType = {}));